import React from 'react';
import { Card, Col, Form, Row } from 'react-bootstrap';
import { useFormContext } from 'react-hook-form';

const CompanyBasicInformation = () => {
  const {
    register,
    formState: { errors }
  } = useFormContext();

  return (
    <Card className="mb-3">
      <Card.Header as="h6" className="bg-light">
        Ерөнхий
      </Card.Header>
      <Card.Body>
        <Row className="gx-2 gy-3">
          <Col md="12">
            <Form.Group>
              <Form.Label>Илгээгчийн данс:</Form.Label>
              <Form.Control
                type="text"
                isInvalid={!!errors.fromBankAccount}
                {...register('fromBankAccount')}
              />
              <Form.Control.Feedback type="invalid">
                {errors.fromBankAccount?.message}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>

          <Col md="12">
            <Form.Group>
              <Form.Label>Төлсөн дүн:</Form.Label>
              <Form.Control
                type="text"
                isInvalid={!!errors.paidmoney}
                {...register('paidmoney')}
              />
              <Form.Control.Feedback type="invalid">
                {errors.paidmoney?.message}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default CompanyBasicInformation;
